// ============================================================
// useMirror - a ref that always holds this render's value.
//
// For callbacks that outlive the render that made them: a listener
// subscribed once, a verb that awaits the server and must act on the
// table as it is NOW, not as it was at the click.
// ============================================================
import { useRef, type MutableRefObject } from 'react';

export default function useMirror<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
